import { ButtonShowMoreLogic as ButtonShowMore } from './ButtonShowMore.logic'

export default ButtonShowMore
